import React,{useState,useEffect,useRef}from 'react'
import Main from '../../cpn/Main'
import { Table,Button,Space,Modal,message,Form,Input,} from 'antd';
import { useGoodsTypeAddMutation, useGoodsTypeDelMutation, useGoodsTypeListQuery, useGoodsTypeUpdateQuery, useGoodsTypeUpdateSaveMutation } from '../../store/BnsKeJiApi';
import { useSearchParams } from 'react-router-dom';

function FirmTypeGoods() {
    const [param] = useSearchParams();
    //新增产品类型-----------------------------------------------------------------------------------------------------------------------------新增产品类型
    const [form] = Form.useForm();
    const [openAdd, setOpenAdd] = useState(false);
    const onCreateClient = (values) => {
        console.log('Received values of form: ', values);
        setOpenAdd(false);
    };
    const [infoAdd,setInfoAdd] = useState({
        egt_content:'',
    });
    const [submitAdd] = useGoodsTypeAddMutation()
    const modalAdd= <Modal
                        open={openAdd}
                        title='新增产品类型'
                        okText="提交"
                        cancelText="取消"
                        onCancel={() => {setOpenAdd(false);}}
                        onOk={() => {
                            form
                                .validateFields()
                                .then((values) => {
                                    form.resetFields();
                                    onCreateClient(values);
                                })
                                .catch((info) => {
                                    console.log('Validate Failed:', info);
                                });
                            submitAdd({
                                egt_name:infoAdd.egt_name,
                                egt_e_id:localStorage.getItem('e_id'),
                                egt_uid:localStorage.getItem('eu_id'),
                                egt_uname:localStorage.getItem('eu_name'),
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('新增成功！')  
                                    setOpenAdd(false)                         
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('新增失败！'+res.data.Message)
                                }
                            })
                        }}
                    >
                        <Form
                            form={form}
                            layout="horizonal"
                            name="form_client"
                            initialValues={{modifier: 'public',}}
                            labelCol={{ span: 7 }}
                        >                            
                            <Form.Item name="name" label='产品类型名称' wrapperCol={{span:10}} required>
                                <Input  onChange={(e) => {setInfoAdd(prevState=>({...prevState,egt_name:e.target.value}))}}/>
                            </Form.Item>
                        </Form>
                    </Modal> 
    //修改产品类型-----------------------------------------------------------------------------------------------------------------------------修改产品类型
    const [openEdit, setOpenEdit] = useState(false);
    const [editId,setEditId] = useState()
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpenEdit(false);
    };
    const [infoEdit,setInfoEdit] = useState();
    const editForm = useRef()
    const {data:dataEdit,isSuccess:isSuccessEdit} = useGoodsTypeUpdateQuery({egt_id:editId})
    useEffect(() => {
        if(isSuccessEdit){
            if(dataEdit.Status==='success'){
                console.log(dataEdit);
                editForm.current.setFieldsValue({
                    egt_name:dataEdit.Result.egt_name,
                    egt_content:dataEdit.Result.egt_content,
                })
                setInfoEdit(prevState=>({...prevState,
                    egt_name:dataEdit.Result.egt_name,
                    egt_content:dataEdit.Result.egt_content,              
                }))
            }
        }
    },[dataEdit,isSuccessEdit])
    const [submitUpdateSave] = useGoodsTypeUpdateSaveMutation()
    const modalEdit = <Modal
                        open={openEdit}
                        title='修改产品类型'
                        okText="提交"
                        cancelText="取消"
                        onCancel={() => {setOpenEdit(false);}}
                        onOk={() => {
                            form
                                .validateFields()
                                .then((values) => {
                                    form.resetFields();
                                    onCreateEdit(values);
                                })
                                .catch((info) => {
                                    console.log('Validate Failed:', info);
                                });
                            submitUpdateSave({
                                egt_name:infoEdit.egt_name,
                                egt_e_id:localStorage.getItem('e_id'),
                                egt_update_uid:localStorage.getItem('eu_id'),
                                egt_update_uname:localStorage.getItem('eu_name'),
                                egt_id:editId,
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功！')   
                                    setOpenEdit(false)                             
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败！'+res.data.Message)
                                }
                            })
                        }}
                    >
                        <Form
                            form={form}
                            layout="horizonal"
                            name="form_client_edit"
                            initialValues={{modifier: 'public',}}
                            labelCol={{ span: 7 }}
                            ref={editForm}
                        >
                            <Form.Item name="egt_name" label='产品类型名称' wrapperCol={{span:10}} required>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,egt_name:e.target.value}))}}/>
                            </Form.Item>
                        </Form>
                    </Modal>
    //删除产品类型-----------------------------------------------------------------------------------------------------------------------------删除产品类型
    const {confirm} = Modal; 
    const [submitDel] = useGoodsTypeDelMutation()
    //产品类型列表-----------------------------------------------------------------------------------------------------------------------------产品类型列表
    
    const {data,isSuccess} = useGoodsTypeListQuery({egt_e_id:localStorage.getItem('e_id')})
    
    const [list, setList] = useState();
    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                //console.log(data);
                
                const newArr = data.Result.map(item => {
                    const {egt_id:key,egt_name,egt_content,egt_uname,egt_ctime,egt_update_ctime,egt_update_uname,goods_num} = item;
                    return item = {key,egt_name,egt_content,egt_uname,egt_ctime,egt_update_ctime,egt_update_uname,goods_num}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.egt_ctime;
                    let bTimeString = b.egt_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])      
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
       
        {
            key: 'type',
            title: '产品类型名称',
            dataIndex: 'egt_name',
        },                            
        {
            key: 'goods_num',
            title: '产品数量',
            dataIndex: 'goods_num',
        },       
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.egt_ctime + record.egt_uname}</div>
                    <div>修改时间：{record.egt_update_ctime + record.egt_update_uname}</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space direction='vertical'>                        
                        <a onClick={() => {
                            setEditId(record.key);
                            setOpenEdit(true)
                        }}>修改</a>
                        <a onClick={() => {
                            confirm({
                                title: '确定删除吗?',
                                content: '删除后不能恢复',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({egt_id:record.key}).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main  topActive='BnsFirm' app='goldfish' t1={param.get('name')} t2='数据类型' t3='产品类型'>
            <div>
                <Button type='primary' onClick={() => {setOpenAdd(true);}}>新增产品类型</Button>
            </div>
            <Table columns={columns} style={{marginTop:'20px'}} dataSource={list}></Table> 
            {modalAdd}
            {modalEdit}            
        </Main>
    )
}

export default FirmTypeGoods